var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62175 5.27754L12.2878 2.89397C12.8026 2.6774 13.395 2.92447 13.6034 3.44264L14.2757 5.11468M17.2196 9.24312H13.6822C12.5777 9.24312 11.6822 10.1385 11.6822 11.2431V11.5092C11.6822 12.6137 12.5777 13.5092 13.6822 13.5092H17.2196M17.5 8.3211V14.5C17.5 16.1569 16.1569 17.5 14.5 17.5H5.5C3.84315 17.5 2.5 16.1569 2.5 14.5V8.3211C2.5 6.66425 3.84315 5.3211 5.5 5.3211H14.5C16.1569 5.3211 17.5 6.66425 17.5 8.3211Z",
    stroke: "#E9EAF2",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceLight);
export default __webpack_public_path__ + "static/media/balanceLight.1bcd2813c15d529204ad95c35119065c.svg";
export { ForwardRef as ReactComponent };